import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=5922868e&scoped=true&"
import script from "./SummaryOrder.vue?vue&type=script&lang=ts&"
export * from "./SummaryOrder.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=5922868e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922868e",
  null
  
)

export default component.exports